
export enum StatusAvaliacaoEnum {
  NaoAvaliado = 'NaoAvaliado',
  Aprovado = 'Aprovado',
  Reprovado = 'Reprovado',
  EmAnalise = 'EmAnalise',
}
